export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export interface ComicItem {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  latestChapter: string;
  updateDate: string;
  description: string;
  tags: string[];
  views: number;
  status: '连载中' | '已完结';
  totalChapters: number;
}

export const categories: ComicCategory[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 1280 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 960 },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line', count: 1120 },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', count: 680 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 840 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 920 },
  { slug: 'school', name: '校园', icon: 'ri-building-line', count: 760 },
  { slug: 'horror', name: '惊悚', icon: 'ri-ghost-line', count: 420 },
];

export const featuredComics: ComicItem[] = [
  {
    id: 'comic-001',
    title: '我的契约恋人',
    author: '金敏秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20style%2C%20soft%20pink%20and%20peach%20warm%20tones%2C%20young%20couple%20in%20romantic%20embrace%2C%20beautiful%20illustration%20with%20delicate%20lineart%2C%20dreamy%20atmosphere%2C%20soft%20bokeh%20background%2C%20manhwa%20webtoon%20style%2C%20elegant%20character%20design%2C%20pastel%20color%20palette%2C%20clean%20composition&width=800&height=1100&seq=comic-cover-001&orientation=portrait',
    category: '恋爱',
    rating: 4.9,
    latestChapter: '第128话',
    updateDate: '2026-07-02',
    description: '一场意外的契约，让两个陌生人的命运纠缠在一起。当她签下那份婚约协议时，从未想过会真正爱上这个冷酷的总裁。',
    tags: ['契约婚姻', '总裁', '甜宠', '都市'],
    views: 8920000,
    status: '连载中',
    totalChapters: 128,
  },
  {
    id: 'comic-002',
    title: '剑与魔法纪元',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20epic%20sword%20and%20magic%20theme%2C%20warrior%20holding%20glowing%20sword%2C%20mint%20green%20and%20teal%20color%20scheme%2C%20magical%20energy%20effects%2C%20dramatic%20lighting%2C%20detailed%20armor%20design%2C%20fantasy%20illustration%2C%20webtoon%20style%2C%20atmospheric%20background%20with%20ancient%20ruins&width=800&height=1100&seq=comic-cover-002&orientation=portrait',
    category: '奇幻',
    rating: 4.8,
    latestChapter: '第95话',
    updateDate: '2026-07-01',
    description: '在剑与魔法并存的大陆上，一个普通少年意外获得传说中的圣剑，从此踏上改变世界的旅程。',
    tags: ['异世界', '冒险', '热血', '成长'],
    views: 7650000,
    status: '连载中',
    totalChapters: 95,
  },
  {
    id: 'comic-003',
    title: '暗夜追踪者',
    author: '李在勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20thriller%20manhwa%20cover%2C%20noir%20style%2C%20dark%20gray%20and%20charcoal%20tones%20with%20red%20accents%2C%20mysterious%20detective%20in%20trench%20coat%2C%20rainy%20city%20street%20at%20night%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20webtoon%20illustration%2C%20gritty%20atmosphere%2C%20neon%20reflections&width=800&height=1100&seq=comic-cover-003&orientation=portrait',
    category: '悬疑',
    rating: 4.7,
    latestChapter: '第73话',
    updateDate: '2026-06-30',
    description: '退役特工被卷入一场惊天阴谋，每一条线索都指向一个更大的秘密。黑夜中的追踪，真相即将浮出水面。',
    tags: ['悬疑', '推理', '动作', '都市'],
    views: 6210000,
    status: '连载中',
    totalChapters: 73,
  },
  {
    id: 'comic-004',
    title: '甜蜜校园日记',
    author: '崔恩智',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%2C%20warm%20yellow%20and%20brown%20tones%2C%20cute%20high%20school%20students%20in%20uniform%2C%20cherry%20blossom%20background%2C%20sweet%20and%20youthful%20atmosphere%2C%20pastel%20color%20palette%2C%20spring%20vibes%2C%20gentle%20illustration%20style%2C%20clean%20lineart%2C%20wholesome%20webtoon%20aesthetic&width=800&height=1100&seq=comic-cover-004&orientation=portrait',
    category: '校园',
    rating: 4.6,
    latestChapter: '第156话',
    updateDate: '2026-07-03',
    description: '转学第一天就遇到青梅竹马？高中生活的甜蜜与烦恼，青春的故事从这里开始。',
    tags: ['校园', '青春', '甜宠', '日常'],
    views: 10350000,
    status: '连载中',
    totalChapters: 156,
  },
];

export const latestComics: ComicItem[] = [
  {
    id: 'comic-005',
    title: '重生之豪门千金',
    author: '郑秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20soft%20pink%20and%20rose%20tones%2C%20elegant%20woman%20in%20luxurious%20evening%20gown%2C%20chandelier%20background%2C%20sophisticated%20atmosphere%2C%20webtoon%20style%20illustration%2C%20refined%20character%20design%2C%20pearl%20accents%2C%20soft%20lighting&width=800&height=1100&seq=comic-cover-005&orientation=portrait',
    category: '剧情',
    rating: 4.8,
    latestChapter: '第210话',
    updateDate: '2026-07-03',
    description: '重生回到十年前，她发誓要改写命运。这一次，她不会再做任人宰割的羔羊。',
    tags: ['重生', '逆袭', '豪门', '女性向'],
    views: 12800000,
    status: '连载中',
    totalChapters: 210,
  },
  {
    id: 'comic-006',
    title: '幽灵教室',
    author: '吴成民',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20cover%2C%20eerie%20mint%20green%20and%20dark%20tones%2C%20haunted%20classroom%20scene%2C%20ghostly%20figure%2C%20spooky%20atmosphere%2C%20foggy%20background%2C%20mysterious%20vibes%2C%20webtoon%20horror%20illustration%2C%20subtle%20supernatural%20elements&width=800&height=1100&seq=comic-cover-006&orientation=portrait',
    category: '惊悚',
    rating: 4.5,
    latestChapter: '第42话',
    updateDate: '2026-07-02',
    description: '深夜的教室里传来诡异的声响，一群学生决定揭开学校隐藏的秘密。',
    tags: ['恐怖', '校园', '超自然', '悬疑'],
    views: 3890000,
    status: '连载中',
    totalChapters: 42,
  },
  {
    id: 'comic-007',
    title: '武林至尊',
    author: '韩正宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%2C%20warm%20brown%20and%20gold%20tones%2C%20martial%20artist%20in%20traditional%20hanbok%2C%20mountain%20landscape%20background%2C%20dynamic%20action%20pose%2C%20ink%20wash%20painting%20style%20mixed%20with%20webtoon%2C%20dramatic%20wind%20effects%2C%20elegant%20composition&width=800&height=1100&seq=comic-cover-007&orientation=portrait',
    category: '动作',
    rating: 4.9,
    latestChapter: '第188话',
    updateDate: '2026-07-01',
    description: '少年在悬崖下获得绝世武功秘籍，从此踏上武林巅峰之路。',
    tags: ['武侠', '热血', '成长', '古风'],
    views: 9460000,
    status: '连载中',
    totalChapters: 188,
  },
  {
    id: 'comic-008',
    title: '猫咪咖啡厅',
    author: '林秀晶',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20slice%20of%20life%20manhwa%20cover%2C%20warm%20yellow%20and%20cream%20tones%2C%20cute%20cats%20in%20cozy%20cafe%20setting%2C%20barista%20character%2C%20wholesome%20vibes%2C%20soft%20illustration%2C%20pastel%20colors%2C%20comforting%20atmosphere%2C%20webtoon%20style%2C%20clean%20simple%20composition&width=800&height=1100&seq=comic-cover-008&orientation=portrait',
    category: '搞笑',
    rating: 4.7,
    latestChapter: '第89话',
    updateDate: '2026-07-02',
    description: '一家神奇的猫咪咖啡厅，每只猫咪都有自己的故事。温馨治愈的日常喜剧。',
    tags: ['治愈', '日常', '美食', '萌宠'],
    views: 5780000,
    status: '已完结',
    totalChapters: 89,
  },
  {
    id: 'comic-009',
    title: '星际漂流者',
    author: '姜道贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20cover%2C%20deep%20space%20theme%2C%20dark%20gray%20and%20cool%20silver%20tones%2C%20astronaut%20floating%20in%20space%2C%20nebula%20background%2C%20futuristic%20spaceship%2C%20cosmic%20atmosphere%2C%20webtoon%20illustration%2C%20dramatic%20lighting%2C%20epic%20scale&width=800&height=1100&seq=comic-cover-009&orientation=portrait',
    category: '奇幻',
    rating: 4.6,
    latestChapter: '第56话',
    updateDate: '2026-06-29',
    description: '22世纪，人类开始在星际间漂流。一艘失联的探索船带回了改变人类文明的信息。',
    tags: ['科幻', '太空', '冒险', '未来'],
    views: 4120000,
    status: '连载中',
    totalChapters: 56,
  },
  {
    id: 'comic-010',
    title: '皇后的秘密',
    author: '金秀贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20romance%20manhwa%20cover%2C%20soft%20peach%20and%20rose%20gold%20tones%2C%20beautiful%20queen%20in%20traditional%20Korean%20hanbok%2C%20palace%20interior%20background%2C%20elegant%20and%20regal%20atmosphere%2C%20ornate%20details%2C%20webtoon%20illustration%2C%20refined%20character%20design&width=800&height=1100&seq=comic-cover-010&orientation=portrait',
    category: '剧情',
    rating: 4.8,
    latestChapter: '第134话',
    updateDate: '2026-07-03',
    description: '身为皇后却隐藏着惊天秘密，宫廷中的每一步都如履薄冰。爱与权力的博弈。',
    tags: ['宫廷', '古风', '权谋', '爱情'],
    views: 8760000,
    status: '连载中',
    totalChapters: 134,
  },
  {
    id: 'comic-011',
    title: '热血格斗家',
    author: '赵泰浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fighting%20action%20manhwa%20cover%2C%20warm%20coral%20and%20orange%20tones%2C%20fighter%20in%20dynamic%20punching%20pose%2C%20boxing%20ring%20background%2C%20explosive%20energy%2C%20motion%20lines%2C%20intense%20expression%2C%20webtoon%20action%20style%2C%20dramatic%20lighting%20from%20above&width=800&height=1100&seq=comic-cover-011&orientation=portrait',
    category: '动作',
    rating: 4.7,
    latestChapter: '第167话',
    updateDate: '2026-07-02',
    description: '地下格斗场的王者，用拳头打出一片天地。每一场战斗都是生死的较量。',
    tags: ['格斗', '热血', '竞技', '都市'],
    views: 7120000,
    status: '连载中',
    totalChapters: 167,
  },
  {
    id: 'comic-012',
    title: '花店物语',
    author: '孙美英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20florist%20in%20beautiful%20flower%20shop%2C%20sunlit%20interior%2C%20various%20blooming%20flowers%2C%20peaceful%20atmosphere%2C%20gentle%20illustration%2C%20pastel%20watercolor%20feel%2C%20webtoon%20style&width=800&height=1100&seq=comic-cover-012&orientation=portrait',
    category: '剧情',
    rating: 4.5,
    latestChapter: '第78话',
    updateDate: '2026-06-28',
    description: '一间小小的花店，承载着每个人的喜怒哀乐。每一束花背后都有一个温暖的故事。',
    tags: ['治愈', '日常', '温情', '都市'],
    views: 3450000,
    status: '已完结',
    totalChapters: 78,
  },
];

export const faqItems = [
  {
    question: '韩漫画网需要付费吗？',
    answer: '韩漫画网提供免费漫画弹窗入口，大部分漫画资源均可免费在线阅读。我们致力于为漫画爱好者提供安全可靠的正版漫画阅读体验，让每一位读者都能尽情享受高质量漫画。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '平台上的漫画每日更新，热门连载作品通常每周更新1-2话。您可以在首页"最新更新"区域查看每日更新的漫画列表，确保不会错过任何精彩内容。',
  },
  {
    question: '如何查找特定类型的漫画？',
    answer: '您可以通过首页的分类导航区域，按恋爱、奇幻、动作、悬疑、搞笑、剧情、校园、惊悚等类型浏览漫画。也可以使用搜索功能直接查找您喜欢的作品名称或作者。',
  },
  {
    question: '平台的漫画资源是否正版？',
    answer: '是的，韩漫画网作为海量正版漫画在线阅读平台，所有漫画内容均获得正版授权，内容安全可靠。我们与多家韩国漫画出版社保持紧密合作，确保每一位读者都能享受到高质量的阅读体验。',
  },
  {
    question: '是否支持手机阅读？',
    answer: '韩漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用哪种设备，都能获得流畅舒适的漫画阅读体验。',
  },
  {
    question: '如何获取最新漫画更新通知？',
    answer: '您可以通过订阅我们的邮件通知服务，第一时间获取您关注的漫画更新信息。我们也会在首页及时展示最新更新的漫画列表。',
  },
];